<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('clients') }} {{ $t('and') }} {{ $t('segments') }} -> {{ $t('create-client') }}
    </h1>
    <div class="main__body">
      <div class="form-row">
        <div class="form-group">
          <label>Фамилия</label>
          <input type="text" placeholder="Фамилия" v-model="user.middleName">
          <span class="error" v-if="errors.middlename">{{ errors.middlename[0] }}</span>
        </div>
        <div class="form-group">
          <label>Имя</label>
          <input type="text" placeholder="Имя" v-model="user.firstName">
          <span class="error" v-if="errors.firstname">{{ errors.firstname[0] }}</span>
        </div>
        <div class="form-group">
          <label>Отчество</label>
          <input type="text" placeholder="Отчество" v-model="user.lastName">
          <span class="error" v-if="errors.lastname">{{ errors.lastname[0] }}</span>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>Телефон</label>
          <masked-input v-model="user.phone" mask="\+\7 111 111 1111" placeholder="Телефон"/>
          <span class="error" v-if="errors.phone">{{ errors.phone[0] }}</span>
        </div>
        <div class="form-group">
          <label>Email</label>
          <input type="email" placeholder="Email" v-model="user.email">
          <span class="error" v-if="errors.email">{{ errors.email[0] }}</span>
        </div>
    </div>
    <div class="form-row mt-1">
      <button class="btn btn-primary" type="submit" @click="createClient">Сохранить</button>
    </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import maskedInput from "vue-masked-input";
export default {
  name: 'createClient',
  data: function(){
    return{
      user: {
        middleName: null,
        firstName: null,
        lastName: null,
        phone: null,
        email: null,
        user_id: this.$store.getters.user
      },
      errors: [],
    }
  },
  methods: {
    createClient: function(){
      axios.post('createClient', this.user).then(response => {
        var status = response.data.status;
        if(status){
          this.user.middleName = null;
          this.user.firstName = null;
          this.user.lastName = null;
          this.user.phone = null;
          this.user.email = null;
          this.errors = [];
          this.$toast.success("Клиент успешно создан");
        }else{
          this.errors = response.data.errors;
        }
      });
    }
  },
  components: {
    maskedInput
  }
}
</script>



